export const SUPPORT_MIN_AMOUNT = 100
export const SUPPORT_MAX_AMOUNT = 5000
export const SUPPORT_FEE_TIER_1 = 13
export const SUPPORT_FEE_TIER_2 = 11
export const SUPPORT_FEE_TIER_3 = 9
